<template>
  <div style="margin-bottom: 10px">
    <el-card class="box-card" style="margin-top: 3px">
      <div slot="header" class="clearfix">
        <span>排名奖励</span>
        <el-button
          style="float: right"
          type="primary"
          icon="el-icon-plus"
          @click="openDialog(true, null)"
          >新增排名奖励</el-button
        >
      </div>
      <el-form-item
        label-width="160px"
        label="参与活动最低关卡ID："
        prop="condition"
      >
        <el-input style="width: 120px" v-model="data.condition"></el-input>
      </el-form-item>
      <el-table
        :data="data.leaderboard"
        border
        size="small"
        style="width: 551px; margin-top: 10px"
      >
        <el-table-column
          prop="range"
          label="排名区间"
          align="center"
          width="100"
        >
          <template scope="scope">
            {{ scope.row.rankRange[0] == scope.row.rankRange[1] ? scope.row.rankRange[0] : `${scope.row.rankRange[0]} - ${scope.row.rankRange[1]}` }}
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="label"
          label="奖励"
          align="center"
          width="350"
        >
          <template scope="scope">
            <ShowItems :items="scope.row.reward" />
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" align="center" width="100">
          <template slot-scope="scope">
            <span
              class="link-button"
              style="color: red"
              @click="remove(scope.$index)"
              >删除</span
            >
            <span
              class="link-button"
              @click="openDialog(false, scope.row, scope.$index)"
              >编辑</span
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import ShowItems from "./components/ShowItems";
export default {
  data() {
    return {
      data: {},
    };
  },
  components: {
    ShowItems,
  },

  watch: {
    data: {
      async handler() {
        await this.updatedParam();
      },
      deep: true,
    },
  },

  async created() {
    await this.loadConfig();
    if (this.parameter) {
      this.data = JSON.parse(this.parameter);
    }
  },

  props: {
    parameter: "",
  },

  methods: {
    async loadConfig() {},
    async openDialog(isCreated, entry, index) {
      let that = this;
      this.$dialogutil.open("EditActivityLeaderboardDialog", {
        closedCallback: async (param) => {
          if (param != null) {
            if (isCreated) {
              that.data.leaderboard.push(param);
            } else {
              this.$set(that.data.leaderboard, index, param);
            }

            this.data.leaderboard.sort((x, y) => {
              return x.rankRange[0] - y.rankRange[0];
            });

            await this.updatedParam();
          }
        },
        data: { isCreated, entry },
      });
    },
    async remove(index) {
      try {
        // 弹确认框
        await this.$confirm(
          `确认删除排名区间[${this.data.leaderboard[index].rankRange}]的配置？`
        );
        this.data.leaderboard.splice(index, 1);

        await this.updatedParam();
      } catch (error) {}
    },

    async updatedParam() {
      if (typeof this.data.condition == "string") {
        this.data.condition = Number(this.data.condition);
      }

      this.$emit("updated", JSON.stringify(this.data), async () => {
        for (let index = 0; index < this.data.leaderboard.length; index++) {
          if (index == 0) {
            continue;
          }
          let entry = this.data.leaderboard[index];
          let preEntry = this.data.leaderboard[index - 1];
          if (entry.rankRange[0] - preEntry.rankRange[1] != 1) {
            return { errMsg: "各个排名区之间必须前后衔接" };
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.link-button {
  padding-left: 5px;
  padding-right: 5px;
  color: rgb(37, 148, 240);

  cursor: pointer;
}

/deep/ .el-table__row td {
  padding: 0px 0;
}

.el-table .cell.el-tooltip {
  white-space: normal;
}
</style>